import React from 'react'
import PropTypes from 'prop-types'
import { IconManager, coreIconPack } from '@deseretbook/react-ui'
import ReactJWPlayer from 'react-jw-player'

IconManager.register(coreIconPack)

/**
 * Additional content for product page.
 *
 * @returns {function} Component
 */
export const JWPlayerContainer = ({ libraryUrl, videoUrl, videoPoster, videoContainerId }) => {
  /**
   * Set the video to fullscreen when clicked
   * @param {string} videoContainerId - Video player div id
   */
  const enterFullscreen = () => {
    const player = document.getElementById(videoContainerId)

    if (player.requestFullscreen) {
      player.requestFullscreen()
    }
  }

  /**
   * Set the video to fullscreen when clicked
   * @param {string} videoContainerId - Video player div id
   */
  const removePlayer = () => {
    const player = document.getElementById(videoContainerId)

    if (player.remove) {
      player.remove()
    }
  }

  return (
    <ReactJWPlayer
      image={videoPoster}
      playerId={videoContainerId}
      playerScript={libraryUrl}
      file={videoUrl}
      onOneHundredPercent={() => {
        document.exitFullscreen()
        removePlayer()
      }}
      isAutoPlay
    />
  )
}

JWPlayerContainer.propTypes = {
  libraryUrl: PropTypes.string,
  videoUrl: PropTypes.string,
  videoPoster: PropTypes.string,
  videoContainerId: PropTypes.string,
}
